import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotFoundError } from '../../errors/NotFoundError';
import { PaymentModeDisplay, PaymentCollectionResponseByTransactionId } from '../../model/payment/PaymentCollectionRequest';
import { PaymentCollectionService } from '../../service/payment-collection.service';
import { ConfigService } from '../../service/config.service';
import { FinzyVersion } from '../../model/common/investment-product';
import { Keys, StorageService } from '../../service/storage.service';

@Component({
  selector: 'app-payment-failure',
  templateUrl: './payment-failure.component.html',
  styleUrls: ['./payment-failure.component.scss']
})
export class PaymentFailureComponent implements OnInit {

  // input row one to payment failure template
  rowOne = {
    failureLogo: "../../../assets/images/payment-collection/payment_failed.svg",
    failureMsg: "Payment Failed",
    failureInfoMsg: "Some technical issue at our end. If the amount was debited, it will be refunded into the original source of payment within 5-7 working days."
  };

  rowTwo = [
    { rowName: 'Payment Type', rowValue: null },
    { rowName: 'Amount', rowValue: null },
    { rowName: 'Transaction ID', rowValue: null },
  ];

  templateButtonText = "TRY AGAIN";


  public transactionId: string;
  public transactionDetail: PaymentCollectionResponseByTransactionId;
  private getActiveFinzyVersion: string

  constructor(private paymentCollectionService: PaymentCollectionService, private route: ActivatedRoute,
    private router: Router, private configService: ConfigService, private storageService: StorageService) {
  }

  ngOnInit(): void {
    const paymentFailureRedirectURI = this.storageService.getItem(Keys.PAYMENT_FAILED_REDIRECT_URL)
    if (paymentFailureRedirectURI) {
      location.href = paymentFailureRedirectURI;
    }
    this.transactionId = this.route.snapshot.queryParams['transactionId'];
    this.getActiveFinzyVersion = this.configService.getActiveFinzyVersion();
    this.getTransactionDetail();
  }

  private navigateTo() {
    const paymentProduct = this.storageService.getItem('paymentProduct');
    if (paymentProduct === 'LOAN_EMI_PAYMENT') {
      this.getPaymentType();
    } else if (this.getActiveFinzyVersion === FinzyVersion.FINZY_V2) {
      this.router.navigate(['/investment-initial']);
    } else {
      this.router.navigate(['investorwallet']);
    }
  }

  async getTransactionDetail() {
    try {

      // This condition is just verify failed is it failed from payment link
      const isUserComingFromPaymentLink = this.isUserComingFromPaymentLink();
      if(isUserComingFromPaymentLink) {
        this.storageService.saveItem(Keys.TRANSACTION_STATUS, 'paymentLinkTransactionFailed')
      }

      this.transactionDetail = await this.paymentCollectionService.getPaymentCollectionByTransactionId(this.transactionId);
      if (this.transactionDetail.status === 'FAILED_TO_BE_COLLECTED') {

        this.rowTwo[1].rowValue = this.transactionDetail.amount;
        this.rowTwo[2].rowValue = this.transactionDetail.transactionId;

        if (this.transactionDetail.paymentMode === 'DEBIT_CARD') {
          this.transactionDetail.paymentMode = PaymentModeDisplay.DEBIT_CARD;
          this.rowTwo[0].rowValue = PaymentModeDisplay.DEBIT_CARD;
        } else if (this.transactionDetail.paymentMode === 'UPI') {
          this.transactionDetail.paymentMode = PaymentModeDisplay.UPI;
          this.rowTwo[0].rowValue = PaymentModeDisplay.UPI;
        } else if (this.transactionDetail.paymentMode === 'NET_BANKING') {
          this.transactionDetail.paymentMode = PaymentModeDisplay.NET_BANKING;
          this.rowTwo[0].rowValue = PaymentModeDisplay.NET_BANKING;
        }
      } else {
        this.navigateTo();
      }
    }
    catch (error) {
      if (error.status === NotFoundError.statusCode) {
        this.navigateTo();
      }
    }
  }

  getPaymentType() {
    this.rowTwo[1].rowValue = this.transactionDetail.amount;
    this.rowTwo[2].rowValue = this.transactionDetail.transactionId;

    if (this.transactionDetail.paymentMode === 'DEBIT_CARD') {
      this.transactionDetail.paymentMode = PaymentModeDisplay.DEBIT_CARD;
      this.rowTwo[0].rowValue = PaymentModeDisplay.DEBIT_CARD;
    } else if (this.transactionDetail.paymentMode === 'UPI') {
      this.transactionDetail.paymentMode = PaymentModeDisplay.UPI;
      this.rowTwo[0].rowValue = PaymentModeDisplay.UPI;
    } else if (this.transactionDetail.paymentMode === 'NET_BANKING') {
      this.transactionDetail.paymentMode = PaymentModeDisplay.NET_BANKING;
      this.rowTwo[0].rowValue = PaymentModeDisplay.NET_BANKING;
    }
  }

  isUserComingFromPaymentLink() {
    const hashedProfileId = this.storageService.getItem(Keys.HASHED_PROFILE_ID);
    const ifaPaymentLinkUuid = this.storageService.getItem(Keys.IFA_PAYMENT_LINK_UUID);
    const profileId = this.storageService.getItem(Keys.PROFILE_ID);
    if (hashedProfileId && ifaPaymentLinkUuid && profileId) {
      return true;
    };
    return false;
  }
}
